import { makeStyles } from "@material-ui/core";

export const css = makeStyles((theme) => ({
    select: {
        width: "421px",
        color: theme.palette.text.primary,
    },
    label: {
        color: theme.palette.text.primary,
        margin: "-4px 15px",
    },
}));
